<script setup>
import CookieNotification from '~/components/CookieNotification.vue';
</script>

<template>
    <el-container>
        <AppHeader />
        <el-main class="main_content">
            <slot />
        </el-main>
        <el-footer>
            <AppFooter />
        </el-footer>
        <CookieNotification/>
    </el-container> 
</template>

<style scoped>
.main_content {
    padding-top: 8px;
    overflow: hidden;
}
</style>